<template>
  <div class="p-5">
    <div class="flex flex-col">
      <p class="font-semibold text-3xl">
        List Approaching Tugboat
      </p>
    </div>
    <table-top
      class="mt-5"
      :page-size-start="false"
      @fetch="fetchNotification"
    />
    <data-table
      class="mt-5"
      :table-header="tableHeaders"
      :table-data="tableData"
      :sort-by="filter.sort_by"
      :sort-dir="filter.sort_dir"
      body-height="100vh"
      @sort="sortTable"
      :loading="isBusy"
    >
      <template #action="{ row }">
        <div class="flex flex-row">
          <div
            class="self-center icon-transparent-bg"
            @click="handleDetail(row.tug_name)"
          >
            <img :src="require('@/assets/shipo-icon-see.svg')">
          </div>
        </div>
      </template>
    </data-table>
    <table-bottom
      class="mt-5"
      @fetch="fetchNotification"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import DataTable from '@/components/dataTable'
import TableBottom from '@/components/tableBottom'
import TableTop from '@/components/tableTop'


export default {
  components: {
    DataTable,
    TableBottom,
    TableTop
  },
  data() {
    return {
      isBusy: false,
      notificationOptions: [],
      filter: {
        sort_by: null,
        sort_dir: null
      },
      tableHeaders: [
        { key: 'action', label: 'Action' },
        { key: 'tug_name', label: 'Tugboat', sortable: true },
        { key: 'trip_number', label: 'Trip Number', sortable: true },
        { key: 'eta', label: 'ETA', sortable: true },
        { key: 'port', label: 'Port', sortable: true },
        { key: 'type_port', label: 'Type Port', sortable: true }
      ],
      tableData: []
    }
  },
  computed: {
    ...mapGetters({
      notifications: 'ApproachingTug/notifications'
    })
  },
  watch: {
    notifications: {
      handler(val) {
        this.tableData = val
      }
    }
  },
  mounted() {
    this.fetchNotification()
  },
  methods: {
    async fetchNotification() {
      try {
        this.isBusy = true
        await this.$store.dispatch('ApproachingTug/fetchNotification', this.filter)
      } catch (err) {
        this.isBusy = false
        this.showFailedNotification(this, 'Cannot fetch data, please try again')
      }
    },
    sortTable(sortBy, sortDir) {
      this.filter.sort_by = sortBy ? sortBy : null
      this.filter.sort_dir = sortDir ? sortDir : null

      this.fetchNotification()
    },
    async handleDetail(tug_name) {
      try {
        const id = await this.$store.dispatch('ApproachingTug/fetchBargeLineUpIdByTugName', { tug_name })
        if (id && !id?.error) {
          await this.$router.push({ name: 'BargeLineUpDetail', params: { id } })
        }
        if (id?.error) {
          this.showFailedNotification(this, `Cannot find BLU with tug name "${tug_name}"`)
        }
      } catch (err) {
        this.showFailedNotification(this, 'Cannot view data, please try again')
      }
    }
  }
}
</script>

  <style lang="scss" scoped>
  .filter-container {
    @apply p-5 mt-5 flex flex-row items-center bg-white rounded-lg;
  }

  /deep/.vs-con-input-label {
    @apply w-full;
  }

  .icon-transparent-bg {
    @apply cursor-pointer;
    @apply min-w-8;
    @apply h-8;
    background-color: rgba(252, 219, 208, 0.36);
    border-radius: 0.5rem;
  }
  </style>
